export abstract class MoveableOverlay {

	id: string;
	variationId: string;
	twinnedId: string;

	position: string;

	alpha: number;
	isCustomTime: boolean;
	startTime: number;
	finishTime: number;
	moveableObject: any;
	moveabaleStyle: any;
	offsetDimensions: any;
	transforms: any;
	animation: any;

	abstract readonly type: string;

	constructor(variationId: string, twinnedId: string) {
		this.id = `f${(~~(Math.random() * 1e8)).toString(16)}`;
		this.variationId = variationId;
		this.twinnedId = twinnedId;

		this.position = 'left-top';
		this.alpha = 1;
		this.isCustomTime = true;
		this.startTime = 0;
		this.finishTime = 0;
		this.moveableObject = {
			draggable: true,
			throttleDrag: 0,
			resizable: false,
			throttleResize: 1,
			keepRatio: true,
			scalable: true,
			throttleScale: 1,
			rotatable: true,
			throttleRotate: 0,
			pinchable: true, // ["draggable", "resizable", "scalable", "rotatable"]
			origin: false,
			snappable: true,
			snapVertical: true,
			snapHorizontal: true,
			snapElement: true,
			snapThreshold: 0,
			snapCenter: true,
		};
		this.moveabaleStyle = {
			width: "23%",
			//height: "30%",
			left: "5%",
			top: "5%",
			//right: 0,
			//bottom: 0,
			position: "absolute",
			userSelect: "none"
		};
		this.offsetDimensions = {
			width: 0,
			height: 0,
		};
		this.transforms = {
			scaleX: 1,
			scaleY: 1,
			translateX: 0,
			translateY: 0,
			rotate: 0
		};
		this.animation = {
			fadeIn: {
				isShow: true,
				type: { id: "default-0", name: "none", title: "None", animateAlpha: false },
				time: 0.2
			},
			fadeOut: {
				isShow: true,
				type: { id: "default-0", name: "none", title: "None", animateAlpha: false },
				time: 0.2
			}
		}
	}

	abstract copy(): MoveableOverlay;
	//static copyFromParsed(parsedObject: any): MoveableOverlay; //Must be in children

	copyProperties(overlayToCopy: MoveableOverlay | any) {
		this.position = overlayToCopy.position;

		this.alpha = overlayToCopy.alpha;
		this.isCustomTime = overlayToCopy.isCustomTime;
		this.startTime = overlayToCopy.startTime;
		this.finishTime = overlayToCopy.finishTime;
		this.moveableObject = JSON.parse(JSON.stringify(overlayToCopy.moveableObject));
		this.moveabaleStyle = JSON.parse(JSON.stringify(overlayToCopy.moveabaleStyle));

		this.moveabaleStyle.transform = undefined;
		if (overlayToCopy.positionData) {
			this.offsetDimensions = {
				width: overlayToCopy.positionData.width,
				height: overlayToCopy.positionData.height,
			}
		} else {
			this.offsetDimensions = JSON.parse(JSON.stringify(overlayToCopy.offsetDimensions));
		}

		if (overlayToCopy.transforms === undefined) {
			this.transforms = {
				scaleX: 1,
				scaleY: 1,
				translateX: 0,
				translateY: 0,
				rotate: 0
			};
		} else {
			this.transforms = JSON.parse(JSON.stringify(overlayToCopy.transforms));
			if (overlayToCopy.transforms.translateX === undefined) {
				this.transforms.translateX = 0;
			}
			if (overlayToCopy.transforms.translateY === undefined) {
				this.transforms.translateY = 0;
			}
			if (overlayToCopy.transforms.rotate === undefined) {
				this.transforms.rotate = 0;
			}
		}
		this.moveableObject.snapThreshold = 0;
		if (overlayToCopy.animation !== undefined) {
			this.animation = JSON.parse(JSON.stringify(overlayToCopy.animation));
		}
	}

	getOverlayCenterXY(videoPreviewPixelsWidth, currentSize) {
		let videoPixelsHeight =
			videoPreviewPixelsWidth /
			currentSize.defaultR;

		let shiftFromLeft = this.moveabaleStyle.left && this.moveabaleStyle.left !== 'unset'
			? this.moveabaleStyle.left
			: this.moveabaleStyle.right && this.moveabaleStyle.right !== 'unset'
				? 100 - parseFloat(this.moveabaleStyle.right) :
				null;
		let shiftFromTop = this.moveabaleStyle.top && this.moveabaleStyle.top !== 'unset'
			? this.moveabaleStyle.top
			: this.moveabaleStyle.bottom && this.moveabaleStyle.bottom !== 'unset'
				? 100 - parseFloat(this.moveabaleStyle.bottom) :
				null;
		let isCalculatedFromRight = this.moveabaleStyle.right && this.moveabaleStyle.right !== 'unset';
		let isCalculatedFromBottom = this.moveabaleStyle.bottom && this.moveabaleStyle.bottom !== 'unset';

		let centerX = (shiftFromLeft !== null
			? parseFloat(shiftFromLeft) / 100 * videoPreviewPixelsWidth + (isCalculatedFromRight ? -1 : 1) * this.offsetDimensions.width / 2
			: videoPreviewPixelsWidth / 2) + this.transforms.translateX;
		let centerY = (shiftFromTop !== null ? parseFloat(shiftFromTop) / 100 * videoPixelsHeight + (isCalculatedFromBottom ? -1 : 1) * this.offsetDimensions.height / 2
			: videoPixelsHeight / 2) + this.transforms.translateY;

		return {
			x: centerX,
			y: centerY,
		}
	}
}